import React from "react";
import JSONPretty from "react-json-pretty";
import './JsonViewPopup.scss';
import { MdClose } from "react-icons/md";
import { toast } from "react-hot-toast";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";
import { IoCopySharp } from "react-icons/io5";

const JsonViewPopup = (props: any) => {
    let { layoutJsonApiLoader } = useSelector((s: any) => s.lmsStore);
    const { data, setJsonViewPopup } = props


    const copyToClipBoardClickHandler = () => {
        const jsonString = JSON.stringify(data);
        navigator.clipboard.writeText(jsonString)
            .then(() => toast.success("Copied."))
            .catch((error) => console.error('method: copyToClipBoardClickHandler: exceptionError ', error));
    }
    return (<>
        <div className="popup-container ">
            <div className="overlay">
                <div className="popup-content popup-card json-popup">
                    <div className="popup-head flex items-start justify-between">
                        <div>
                            <h2>Layout JSON</h2>
                            <p>The response this layout serves to the site.</p>
                        </div>
                        {/* The actions used to float over the JSON itself */}
                        <div className="head-actions flex items-center">
                            <button onClick={copyToClipBoardClickHandler} disabled={layoutJsonApiLoader} className="copy-btn flex items-center rounded">
                                <IoCopySharp />&nbsp; Copy to clipboard
                            </button>
                            <button onClick={() => setJsonViewPopup(false)} title="Close" className="popup-close flex items-center justify-center">
                                <MdClose size={18} />
                            </button>
                        </div>
                    </div>

                    <div className="popup-content-inner popup-body">
                        {layoutJsonApiLoader ? <Loader /> : <JSONPretty data={data} />}
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default JsonViewPopup
